module.exports = __webpack_public_path__ + "img/product_mb_new_04.ba40b25.png";